// App.jsx
import { Col, Form, message, Row } from "antd";
import React, { useState, useEffect, useReducer } from "react";
import liracrypt from "../components/Liracrypt/liracrypt";
import queryString from "query-string";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import { useLocation, useHistory } from 'react-router-dom';
import { LoadingOutlined } from "@ant-design/icons";
import ZenFormInput from "./InputCreater/ZenFormInput";
import FooterButtons from "../components/STORM/FooterButtons";
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import { createRoute } from "../utils/CustomFunc";
import ZenModal from "../components/ZenModal";

const styles = {
    root: {
        height: "100vh",
        margin: 0,
        fontFamily:
            'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans"',
        backgroundColor: "#262626",
        color: "#1a1a1a",
        display: "grid",
        gridTemplateColumns: "280px 1fr",
    },
    sidebar: {
        background: "linear-gradient(135deg, #1a1a1a, #262626, #333333)",
        borderRight: "4px solid #3a3a3a",
        padding: "20px 16px",
        overflow: "auto",
    },
    sidebarTitle: {
        fontWeight: 700,
        letterSpacing: "0.2px",
        color: "#374151", // neutral gray
        marginBottom: 12,
        textTransform: "uppercase",
        fontSize: 12,
    },
    sidebarList: {
        listStyle: "none",
        margin: 0,
        padding: 0,
    },
    sidebarItem: ({ active, disabled, isError }) => {
        const isErrorActive = isError && active;

        return {
            width: "100%",
            textAlign: "left",
            padding: "10px 12px",
            margin: "4px 0",
            borderRadius: 8,
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "160ms ease",
            position: "relative",
            background: isErrorActive
                ? "rgba(220,38,38,0.18)"
                : isError
                    ? "rgba(220,38,38,0.08)"
                    : active
                        ? "rgba(59,130,246,0.08)"
                        : "transparent",
            border: isErrorActive
                ? "1px solid #dc2626"
                : isError
                    ? "1px solid #dc2626"
                    : active
                        ? "1px solid #1677ff "
                        : "1px solid transparent",
            color: isError ? "#dc2626" : "#1677ff",
            boxShadow: isErrorActive
                ? "inset 0 0 4px rgba(220,38,38,0.4), 0 2px 6px rgba(0,0,0,0.08)"
                : active
                    ? "inset 0 0 0 1px rgba(59,130,246,0.2)"
                    : "none",
            transform: isErrorActive ? "scale(1.02)" : "none",
            ...(isErrorActive && {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 4,
                    background: "#dc2626",
                    borderRadius: "8px 0 0 8px",
                },
            }),
            opacity: disabled ? 0.6 : 1,
        };
    },
    content: {
        background:
            "radial-gradient(1200px 600px at 20% 0%, rgba(124,92,255,0.08), transparent 40%), radial-gradient(800px 400px at 70% 30%, rgba(59,130,246,0.08), transparent 40%), #262626",
        padding: 24,
        overflow: "auto",
    },
    contentHeader: {
        display: "flex",
        flexDirection: "column",
        gap: 6,
        marginBottom: 16,
    },
    contentTitle: {
        margin: 0,
        fontSize: 20,
        fontWeight: 700,
        color: "#111827",
    },
    contentSubtitle: {
        margin: 0,
        color: "#6b7280",
        fontSize: 13,
    },
    tableWrap: {
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        overflow: "hidden",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
    },
    th: {
        background: "#f3f4f6",
        color: "#374151",
        textAlign: "left",
        padding: "12px 14px",
        fontSize: 12,
        textTransform: "uppercase",
        letterSpacing: "0.3px",
        borderBottom: "1px solid #e5e7eb",
    },
    td: {
        padding: "12px 14px",
        borderTop: "1px solid #e5e7eb",
        verticalAlign: "top",
    },
    linkBtn: {
        appearance: "none",
        border: "none",
        background: "transparent",
        color: "#2563eb", // blue accent
        fontWeight: 600,
        cursor: "pointer",
        padding: 0,
    },
    empty: {
        textAlign: "center",
        color: "#6b7280",
        padding: "24px 14px",
    },
};

function Sidebar({ sections, activeKey, onSelect, errorTabList = [] }) {
    return (
        <nav style={styles.sidebar} aria-label="Sections">
            {/* <div style={styles.sidebarTitle}>PM Preparation</div> */}
            <ul style={styles.sidebarList}>
                {sections.map((s) => (
                    <li key={s.key}>
                        <button
                            disabled={!s.enable}
                            style={styles.sidebarItem({ active: activeKey === s.key, disabled: !s.enable, isError: errorTabList.includes(s.key) })}
                            onClick={() => onSelect(s.key)}
                            aria-current={activeKey === s.key ? "page" : undefined}
                        // onMouseEnter={(e) => {
                        //     if (activeKey !== s.key) {
                        //         e.currentTarget.style.border = "1px solid #253043";
                        //         e.currentTarget.style.background = "rgba(125,145,175,0.08)";
                        //     }
                        // }}
                        // onMouseLeave={(e) => {
                        //     if (activeKey !== s.key) {
                        //         e.currentTarget.style.border = "1px solid transparent";
                        //         e.currentTarget.style.background = "transparent";
                        //     }
                        // }}
                        >
                            {s.label}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
const initialState = null;

const reducer = (state, action) => {
    switch (action.type) {
        case "setPageConfig":
            return { ...action.payload }
    }
}
export default function ZenFormSegment({
    urlData = {},
    setPageHeader,
    extraData = {},
    onFormSubmit,
    onCallFinish,
    onResponseCb
}) {
    const [form] = Form.useForm();
    const [pageConfig, dispatch] = useReducer(reducer, initialState);

    const [active, setActive] = useState("");
    const LocalDict = [];
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [loading, setLoading] = useState(true);
    const [dinIndex, setDinIndex] = useState();
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const [selectedButton, setSelectedButton] = useState();
    const history = useHistory();
    const urlCode = useSelector(state => state.urlCode);
    const [errorTabList, setErrorTabList] = useState([]);
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        type: "",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = "", loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const queryElements = (controls) => {
        return (<Row>
            {
                controls.map((data, index) => {
                    if (dtArray.includes(data["typ"])) {

                        LocalDict[data["data_index"]] = data["format"]
                            ? data["format"]
                            : "YYYY-MM-DD hh:mm:ss";
                        LocalDict["data_index_from"] = data["data_index_from"];
                        LocalDict["data_index_to"] = data["data_index_to"];
                    }

                    if (data.visible) {
                        return (
                            <React.Fragment key={index}>
                                <ZenFormInput
                                    urlData={{ ...urlData }}
                                    childType={data.childType}
                                    pageType={"zenForm"}
                                    header={data.header}
                                    footer={data.footer}
                                    labelColSpan={data["labelColSpan"]}
                                    style={data['style']}
                                    height={data['height']}
                                    layoutPosition="space-between"
                                    form={form}
                                    LocalDict={LocalDict}
                                    rows={data.rows}
                                    colSpan={data.colSize || 12}
                                    name={data["data_index"]}
                                    label={data["label"]}
                                    defaultValue={data["default"]}
                                    typ={data["typ"]}
                                    disabled={data["readOnly"]}
                                    source={data["source"]}
                                    sourceParams={data["sourceParams"]}
                                    auxParams={data["auxParams"]}
                                    format={data["format"]}
                                    errorMessage={data["errorMessage"]}
                                    placeHolder={data["placeHolder"]}
                                    required={data["required"]}
                                    options={data["data"]}
                                    from={data["data_index_from"]}
                                    to={data["data_index_to"]}
                                    url={data["url"]}
                                    includeAll={data["includeAll"]}
                                    pname={data["p_data_index"] || `p_${data["data_index"]}`}
                                    defaultFrom={data["defaultFrom"]}
                                    defaultTo={data["defaultTo"]}
                                    multiSelect={data["multiSelect"]}
                                    searchable={data["isSearchable"]}
                                    data={data}
                                    extraData={extraData}
                                    children={data['children']}
                                />
                            </React.Fragment>
                        );
                    }
                })}
        </Row>)
    }

    const buildDinIndex = (segment) => {
        const index = {};
        for (const sectionKey in segment) {
            const section = segment[sectionKey];
            if (section && Array.isArray(section)) {
                for (const element of section) {
                    if (element.data_index) {
                        index[element.data_index] = sectionKey;
                    }
                    if (element.typ === 'dropDown') {
                        if (element.p_data_index) {
                            index[element.p_data_index] = sectionKey;
                        } else {
                            index[`p_${element.data_index}`] = sectionKey;
                        }
                    }
                }
            }
        }
        return index;
    }

    const fetchAPI = () => {
        setLoading(true);
        liracrypt.get('/textapi', { ...searchParams })
            .then(({ data }) => {
                if (data.isSuccess) {
                    dispatch({
                        type: "setPageConfig",
                        payload: data.config
                    });
                    if (setPageHeader) {
                        setPageHeader(data.config.pageTitle || "ZenForm Segment XXXXXXXXXX")
                    }
                    setActive(data.config.segments.find(x => x.active === true)?.key)
                    setDinIndex(buildDinIndex(data.config.modalElements));
                    setLoading(false);
                } else {
                    message.error(data.message || 'Something went wrong')
                }
            }).catch(err => {
                console.error(err);
                ApiErrorComp();
            })
    }

    useEffect(() => {
        fetchAPI();
    }, [search]);

    const openSmodal = (btnData) => {
        setZenModal(btnData.smodalProp);
        let _urlData = { ...searchParams, ...urlData, ...btnData?.smodalProp?.params };
        if (btnData.smodalProp?.multiProps?.length) {
            btnData.smodalProp?.multiProps.forEach(x => {
                _urlData[x] = form.getFieldValue(x);
            })
        }
        return toggleModal({
            show: true,
            data: {
                urlData: { ..._urlData }
            },
            type: 'smodal',
            loading: false
        });
    }

    const openPopupModal = (btnData) => {
        setZenModal(btnData.smodalProp);
        let _urlData = { ...searchParams, ...urlData, ...btnData?.smodalProp?.params };
        if (btnData.smodalProp?.multiProps?.length) {
            btnData.smodalProp?.multiProps.forEach(x => {
                _urlData[x] = form.getFieldValue(x);
            })
        }
        return toggleModal({
            show: true,
            data: {
                urlData: { ..._urlData }
            },
            type: 'smodal',
            loading: false
        });
    }

    const nextSegment = () => {
        let activeIndx = pageConfig?.segments.findIndex(x => x.key === active);
        if (activeIndx === (pageConfig?.segments.length - 1)) {
            setActive(pageConfig?.segments[0]?.key)
        } else {
            setActive(pageConfig?.segments[activeIndx + 1]?.key)
        }
    }


    const onResponse = ({ data, button, onlyPostSubmitAction }) => {
        if (onResponseCb) {
            return onResponseCb(data);
        }
        if (data && !onlyPostSubmitAction) {
            if (data?.isSuccess) {
                message.success(data?.message || "Submitted Successfully");
            } else {
                message.error(data?.message || "Oops! Something went wrong");
                return;
            };

        }
        let btnData = button || selectedButton;
        if (btnData.buttonProp?.smodal && !onlyPostSubmitAction) {
            return openSmodal(btnData);
        };
        if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
            return openPopupModal(btnData);
        };
        if (!btnData?.buttonProp?.postSubmitAction) {
            if (onCallFinish) {
                form.resetFields();
                onCallFinish({});
            }
            return;
        };

        if (btnData?.postSubmitActionProp?.action === "clearForm") {
            form.resetFields();
        }
        if (btnData?.postSubmitActionProp?.action === "nextSegment") {
            nextSegment();
        }
        if (btnData?.postSubmitActionProp?.action === "newRoute") {
            let route = createRoute({
                route: btnData.postSubmitActionProp.route,
                props: btnData?.postSubmitActionProp?.props,
                multiProps: btnData?.postSubmitActionProp?.multiProps,
                record: data,
                urlCode,
                params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
            });
            history.push(route);
        }
        if (btnData?.postSubmitActionProp?.action === "printZenForm") {
            document.getElementsByClassName('customer-complaint')[0].classList.add('printable');
            document.getElementById('print-form').click();
            setTimeout(() => {
                document.getElementsByClassName('customer-complaint')[0].classList.remove('printable');
            }, 2000);
            return;
        }
        if (btnData?.postSubmitActionProp?.action === "blankPage") {
            dispatch({
                type: 'setPageConfig',
                payload: undefined
            });
        };
        if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
            dispatch({
                type: 'setPageConfig',
                payload: undefined
            });
            fetchAPI();
        }
        if (btnData?.postSubmitActionProp?.action === "newTab") {
            let route = createRoute({
                route: btnData.postSubmitActionProp.route,
                props: btnData?.postSubmitActionProp?.props,
                multiProps: btnData?.postSubmitActionProp?.multiProps,
                record: data,
                urlCode,
                params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
            });
            window.open(route, '_blank');
        };

        if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
            window.location.reload();
        }

        if (btnData?.postSubmitActionProp?.action === 'download') {
            let _urlData = { ...searchParams, ...urlData, ...btnData?.postSubmitActionProp?.params };
            _urlData['token'] = localStorage.getItem("token");
            _urlData['urlCode'] = urlCode;
            let routeParams = new URLSearchParams(_urlData);
            let route = `${process.env.REACT_APP_API_ENDPOINT}${btnData?.postSubmitActionProp?.api}?${routeParams}`;
            window.open(route, '_blank');
            return;
        }
    };


    const findSectionByDin = (dinValue) => {
        return dinIndex[dinValue] || null;
    }


    const onFinish = async (values) => {
        let data = { ...values };
        data = { ...searchParams, ...urlData, ...data };
        Object.keys(data).forEach((key) => {

            if (data[key]) {
                if (Array.isArray(data[key]) && LocalDict[key]) {
                    data[
                        LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
                    ] = dayjs(data[key][0]).format(LocalDict[key]).toString();
                    data[LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"] =
                        dayjs(data[key][1]).format(LocalDict[key]).toString();
                    delete data[key];
                } else {
                    if (LocalDict[key]) {
                        data[key] = dayjs(data[key]).format(LocalDict[key]).toString();
                    }
                }
            }
        });
        let sparkTableData = {};
        Object.keys(data).forEach(x => {
            if (x.includes('lira-spark-')) {
                let sparkId = x.split('lira-spark-')[1].split("--");
                sparkTableData[sparkId[0]] = {
                    ...sparkTableData[sparkId[0]],
                    [sparkId[1]]: data[x]
                };
                delete data[x];
            }
        });
        data = { ...data, tblData: { ...sparkTableData, ...searchParams } };
        let formData = new FormData();
        Object.keys(data).forEach(x => {
            let val = data[x];
            if (typeof val === 'object') {
                if (!(val instanceof File)) {
                    val = JSON.stringify(val);
                }
            }
            formData.append(x, val);
        });

        if (onFormSubmit) {
            return onFormSubmit({ values: data, formData });
        }

        let { method, params, api } = selectedButton?.submitFormDataProp;

        if (params) {
            Object.keys(params).forEach(x => {
                formData.append(x, params[x]);
            })
        };
        let response;
        try {
            if (method === 'POST') {
                response = await liracrypt.post(api, { ...data });
            }
            if (method === 'GET') {
                response = await liracrypt.get(api, { ...data });
            }
            if (method === 'PATCH') {
                response = await liracrypt.patch(api, { ...data });
            }
            onResponse({
                data: response.data,
                button: selectedButton
            })
        } catch (error) {
            console.log(error);
            ApiErrorComp();
        }
    }

    const onError = ({ errorFields }) => {
        let errorItemList = [];
        errorFields.forEach(errItm => {
            console.log(findSectionByDin(errItm.name[0]));
            errorItemList.push(findSectionByDin(errItm.name[0]))
        });
        setErrorTabList(errorItemList);
    }
    return (
        <>

            {
                loading ?
                    <LoadingOutlined spin={true} style={{ fontSize: 18, color: "blue" }} /> :
                    <div style={styles.root}>
                        <Sidebar errorTabList={errorTabList} sections={pageConfig?.segments} activeKey={active} onSelect={setActive} />
                        <main style={styles.content} role="main">
                            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={onResponse} />

                            <div className={'customer-complaint printable'}>
                                <div className="customer-form">
                                    <Form
                                        name="ZenFormSegment"
                                        labelWrap={true}
                                        form={form}
                                        labelCol={{ span: 8 }}
                                        layout={"vertical"}
                                        colon={false}
                                        onFinish={onFinish}
                                        onFinishFailed={onError}
                                        size="large"
                                    >
                                        {
                                            pageConfig?.segments.map((segment) => (
                                                <div key={segment.key} className={segment.key} style={{ display: active === segment.key ? 'block' : 'none' }}>
                                                    {queryElements(pageConfig?.modalElements[segment.key])}
                                                </div>
                                            ))
                                        }
                                        {
                                            pageConfig?.footerButtons && (
                                                <Row style={{ width: '100%' }} gutter={24} justify="center">
                                                    <Col span={24} style={{ display: 'inline-flex', justifyContent: 'center' }}>
                                                        {Object.keys(pageConfig?.footerButtons).map((btn, idx) => {
                                                            const button = pageConfig?.footerButtons[btn];
                                                            const isVisible = pageConfig.segments.find(x => x.key === active)?.footerButtons.includes(btn);
                                                            if (isVisible) {
                                                                return (
                                                                    <React.Fragment key={`zenform-footer-btn-${idx}`}>
                                                                        <FooterButtons
                                                                            onError={onError}
                                                                            // saveForm={({ button }) => saveWithoutValidation({ value: form.getFieldsValue(), button })}
                                                                            postSubmitAction={onResponse}
                                                                            openPopupModal={() => { }}
                                                                            openSmodal={openSmodal}
                                                                            button={button}
                                                                            setSelectedButton={setSelectedButton}
                                                                            form={form}
                                                                            label={button?.buttonProp?.label}
                                                                            type={button?.buttonProp?.type}
                                                                            disabled={!button?.buttonProp?.enable}
                                                                            confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                                                            submitFormData={button?.submitFormDataProp}
                                                                        />
                                                                    </React.Fragment>

                                                                )
                                                            }
                                                        })}
                                                    </Col>
                                                </Row>
                                            )
                                        }
                                    </Form>
                                </div>
                            </div>

                        </main>
                    </div>
            }
        </>
    );
}